import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectActiveTeam, selectActiveTeamPlayerOptions } from 'features/match/matchSlice';

import { inputSliceActions, selectSelects } from 'features/input/inputSlice';

import AdvancedSelect from 'components/AdvancedSelect';

import substitutionIcon from 'assets/images/icons/substitution.svg';
import { useIntl } from 'react-intl';
import selectOnChange from './helpers/selectOnChange';

const EventInputSubstitution: React.FC = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const team = useSelector(selectActiveTeam);
  const selects = useSelector(selectSelects);
  const playerOptions: any = useSelector(selectActiveTeamPlayerOptions);

  useEffect(() => {
    dispatch(inputSliceActions.setActiveSelect(selects.playerOn.id));
  }, []);

  const onChangePlayerOff = (option) => {
    selectOnChange(option, team, dispatch, intl);
  };

  const onChangePlayerOn = (option) => {
    selectOnChange(option, team, dispatch, intl, true);
    dispatch(inputSliceActions.setActiveSelect(selects.playerOff.id));
  };

  return (
    <div className="input-group substitution">
      <AdvancedSelect
        title={intl.formatMessage({ id: 'selectHeader.playerIn' })}
        options={playerOptions?.filter((item) => item.value !== selects?.playerOff?.value)}
        select={selects.playerOn}
        isClearable={true}
        onChange={onChangePlayerOn}
      />
      <img src={substitutionIcon} alt="icon" />
      <AdvancedSelect
        title={intl.formatMessage({ id: 'selectHeader.playerOut' })}
        options={playerOptions?.filter((item) => item.value !== selects?.playerOn?.value)}
        select={selects.playerOff}
        isClearable={true}
        onChange={onChangePlayerOff}
      />
    </div>
  );
};

export default EventInputSubstitution;
